import { Component, ViewChild, ElementRef,
    Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import GatewayDto from '../dto/gateway-dto';
import { EdgeInterfaceDto, IPAssignemntDto } from '../dto/gateway-dto';
import { getNetworkListingDatatableConfig, getAddressGroupListingDatatableConfig } from './add-edit-interface-dialog.dt.config';
import { Observable }  from 'rxjs/Observable';
import { Subscription } from 'rxjs/Rx';
import { NetworkService }  from '../../networks/network.service';
import { Response } from '@angular/http';
const _ = require('lodash');
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { ReturnStatement } from '@angular/compiler/src/output/output_ast';

@Component({
    selector: 'add-edit-interface',
    template: require('./add-edit-interface-dialog.html'),
    providers: [ NetworkService ],
    styles: [require('./add-edit-interface-dialog.scss')]
})

export default class AddEditInterfaceDialog implements OnChanges {
    @Input('interface') interface: EdgeInterfaceDto;
    @Output('onSave') save = new EventEmitter();
    @Output('onCancel') cancel = new EventEmitter();
    @Input('showInterfaceDialog') showInterfaceDialog: boolean;
    @Input('operationMode') operationMode: string;
    @Input('gateway') gateway: GatewayDto;
    @Input('network') networkSelected: any = null;
    @Input('addressGroups')   private addressGroups: any[] = [];

    private addressGroup: IPAssignemntDto;
    private networks: any[];
    private show: boolean = false;
    private connectivityStatus: string = 'Not Connected';
    private interfaceTypes = [
        { value: 'uplink', display: 'Uplink' },
        { value: 'internal', display: 'Internal' },
        { value: 'trunk', display: 'Trunk' }
    ];
    private subscribeHandler: Subscription;
    private selectedAddressGroup: IPAssignemntDto;
    private addressGroupOpMode: string = 'ADD';
    private tableSettings: Object = {};
    private tableConfig: Object = {};
    private addressGrouptableSettings: Object = {};
    private selectedAddressGroupIndex: number;
    private networkIpRangesForSelectedNetwork: string;
    private networkOperationFailed: boolean = false;
    private isNetworkCallInProgress: boolean = false;
    private errorMessage: string;
    private invalidSecondaryAddressErrorMsg: string;

    // Flags
    private invalidSecondaryAddress: boolean = false;
    private isAddressGroupSelected: boolean = false;
    private showAddressGroup: boolean = false;
    private isSubInterface: boolean = false;
    private tunnelID: any;
    private parentInterfaceIndex: number = -1;
    private showIPScope: boolean = true;
    private savedInterfaces = [];
    private showVNIC: boolean = true;
    private hideSubInterface: boolean = true;
    private disableSubInterface: boolean = false;
    private currentVNIC: number = 0;
    constructor(private networkingService: NetworkService,
        private translate: TranslateService,) {
        translate.use(GlobalVariables.LOCALE);
        this.tableConfig = getNetworkListingDatatableConfig();
        Object.assign(this.tableSettings, this.tableConfig, {'data': []});
        this.tableConfig = getAddressGroupListingDatatableConfig();
        Object.assign(this.addressGrouptableSettings, this.tableConfig, {'data':[]});
    }

    ngOnInit() {
    }
    ngOnChanges(change: SimpleChanges) {
        this.disableSubInterface = false;
        let __this = this;
        if (this.showInterfaceDialog) {
            this.showIPScope = true;
            this.isSubInterface = false;
            this.showVNIC = true;
            this.savedInterfaces = [];
            this.parentInterfaceIndex = -1;
            if (this.gateway.interfaces.length > 0) {
                this.gateway.interfaces.forEach(function(item) {
                    if (item.type === 'trunk') {
                        __this.savedInterfaces.push (
                            { index: item.index, name: item.name }
                        );
                    }
                })
            }

            if (this.savedInterfaces.length > 0) {
                this.hideSubInterface = false;
                this.savedInterfaces.unshift(
                    {
                        index: -1,
                        name: 'Select'
                    }
                )
                if (typeof this.interface.parentInterfaceIndex !== "undefined") {
                    this.parentInterfaceIndex = this.interface.parentInterfaceIndex;
                }
            } else {
                this.hideSubInterface = true;
                this.savedInterfaces.push(
                    {
                        index: -1,
                        name: 'No trunk interfaces configured'
                    }
                )
            }

            if (this.operationMode === 'EDIT') {
                if (typeof this.interface.tunnelId !== "undefined") {
                // Subinterface
                    this.isSubInterface = true;
                    this.showVNIC = false;
                    this.disableSubInterface = true;
                } else {
                    this.hideSubInterface = true;
                }
                if (typeof this.interface.type !== "undefined" && this.interface.type === 'trunk') {
                    this.showIPScope = false;
                    this.disableSubInterface = true;
                }
            } else {
                // Add
                this.interface.isNew = true;
                let count = this.getInterfaceCount(this.gateway.interfaces);
                this.currentVNIC = this.interface.index;

                if (count >= 10) {
                    this.isSubInterface = true;
                    this.disableSubInterface = true;
                    this.interface.index = this.getMaxSubInterfaceIndex();
                }
                this.interface["mtu"] = 1500; // default MTU
            }
        }

        if (this.interface) {
            this.updateConnectivityStatus();
        }

    }

    getMaxSubInterfaceIndex() {
        let max: number = 0;
        let interfaces = this.gateway.interfaces;
        for (let i = 0; i < interfaces.length; i++) {
            if (typeof interfaces[i].tunnelId !== "undefined") {
                if (max < interfaces[i].index) {
                    max = interfaces[i].index;
                }
            }
        }
        return (max === 0) ? 10 : ++max
    }

    getInterfaceCount(interfaces) {
        let count = 0;
        interfaces.forEach(function(item) {
            if (typeof item.parentInterfaceIndex === "undefined") {
                count++;
            }
        })
        return count;
    }

    enableAdd(networkId): boolean {
        return networkId ? true : false;
    }

    showRemoveLink(): boolean {
        if (this.interface) {
         if (!(this.interface.networkName === undefined || this.interface.networkName === '')) {
                return true;
            }
        }
        return false;
    }
    getTitle(): string {
        let str: string = '';
        str = (this.operationMode === 'ADD') ? 'Add' : 'Edit';
        str += (this.isSubInterface) ? ' SubInterface' : ' Interface';
        return str;
    }

    onCancel(event) {
        this.cancel.emit();
        this.resetFlags();
        this.initializeData();
    }

    onSave (event) {
        this.interface.addressGroups = this.addressGroups;
        if (this.isSubInterface) {
            if (this.interface.type) {
                // TODO cleanup
            }
        } else if (this.interface.type === 'trunk') {
            if (this.interface.tunnelId) {
                delete this.interface.tunnelId
            }
            if (this.interface.parentInterfaceIndex) {
                delete this.interface.parentInterfaceIndex;
            }
            if (this.interface.addressGroups) {
                delete this.interface.addressGroups;
            }
        } else if (this.interface.type === 'uplink' || this.interface.type === 'internal') {
            if (this.interface.tunnelId) {
                delete this.interface.tunnelId
            }
            if (this.interface.parentInterfaceIndex) {
                delete this.interface.parentInterfaceIndex;
            }
        }

        this.save.emit({
            'interface': this.interface
        });

        this.resetFlags();
        this.initializeData();
    }

    initializeData(): void {
        this.addressGroups = [];
        this.networkSelected = null;
        this.networkIpRangesForSelectedNetwork = null;
    }

    resetFlags(): void {
        this.isAddressGroupSelected = false;
        this.showAddressGroup = false;
    }

    removeNetworkSelection(event) {
        this.interface.networkName = '';
        this.interface.networkId = '';
        this.interface.isConnected = false;
        this.interface.name = '';
        this.networkIpRangesForSelectedNetwork = "";
        this.updateConnectivityStatus();
        this.networkSelected = null;
    }

    openNetworkDialog(event) {
        if (this.interface.type === 'trunk') {
            this.getNetworksByTrunk();
            return;
        }
        this.getNetworks();
    }

    onNetworkSelected(event) {
         if (event && event.value && event.value instanceof Array ) {
           if (event.value[0]) {
               this.networkSelected = event.value[0];
           } else {
               this.networkSelected = null;
            }
        }
    }

    onNetworkSelectionSaved() {
        this.interface.networkId = this.networkSelected.objectId;
        this.interface.networkName = this.networkSelected.name;
        this.interface.isConnected = true;
        this.interface.name = this.interface.networkName;
        this.updateConnectivityStatus();
        this.networkIpRangesForSelectedNetwork = this.getNetworkIpRanges(this.networkSelected.ipScopes);
        this.show = false;
    }

    getNetworksByTrunk() {
        let scopeId = this.gateway.scopeId;
        this.isNetworkCallInProgress = true;
        this.networkingService.getAllNetworksByTrunk(scopeId).subscribe(networks => {
                this.networkOperationFailed = false;
                this.isNetworkCallInProgress = false;
                this.networks = [].concat(networks);
            },
            error => this.handleNetworkOpreationError(error)
        );
        this.show = true;
    }

    getNetworks() {
        let __this = this;
        this.networks = [];
        let scopeId = this.gateway.scopeId;
        this.isNetworkCallInProgress = true;
        this.networkingService.getAllNetworksByScope(scopeId).subscribe(networks => {
                this.networkOperationFailed = false;
                this.isNetworkCallInProgress = false;
                networks.forEach(function(network) {
                    if (typeof network.allowTrunkInterfaces === "undefined" || !network.allowTrunkInterfaces) {
                        __this.networks.push (network);
                    }
                });
            },
            error => this.handleNetworkOpreationError(error)
        );
        this.show = true;
    }

    changeConnectivity(event) {
        this.interface.isConnected = !this.interface.isConnected;
        this.updateConnectivityStatus();
    }

    updateConnectivityStatus() {
        this.connectivityStatus = this.interface.isConnected ? 'Connected' : 'Not Connected';
    }

    onAddressGroupSelected(event) {
        if (event && event.value && event.value instanceof Array ) {
           if (event.value[0]) {
               this.selectedAddressGroup = event.value[0];
               this.isAddressGroupSelected = true;
           } else {
               this.selectedAddressGroup = null;
               this.isAddressGroupSelected = false;
           }
        }
    }

    onAddressGroupCreate(event) {
        this.addressGroup = new IPAssignemntDto();
        this.showAddressGroup = true;
        this.addressGroupOpMode = 'ADD';
        this.networkIpRangesForSelectedNetwork = '';
        if (this.networkSelected && this.networkSelected.ipScopes) {
            this.networkIpRangesForSelectedNetwork = this.getNetworkIpRanges(this.networkSelected.ipScopes);
        }
    }

    onAddressGroupEdit(event) {
        this.addressGroup = _.cloneDeep(this.selectedAddressGroup);
        this.showAddressGroup = true;
        this.addressGroupOpMode = 'EDIT';
        this.networkIpRangesForSelectedNetwork = '';
        if (this.networkSelected && this.networkSelected.ipScopes) {
            this.networkIpRangesForSelectedNetwork = this.getNetworkIpRanges(this.networkSelected.ipScopes);
        }
    }

    onAddressGroupDelete(event) {
        let me = this ;
        _.remove(this.addressGroups, function(item){
            return (
                    me.selectedAddressGroup.primaryAddress === item.primaryAddress && 
                    me.selectedAddressGroup.subnetPrefixLength === item.subnetPrefixLength
            );
        });
        this.addressGroups = [].concat(this.addressGroups);
    }

    saveAddressGroup(formData) {
        let validSecondaryAddresses: boolean = true;
        if (this.addressGroup.secondaryAddresses) {
            validSecondaryAddresses = this.areSecondaryAddressesValid(this.addressGroup.secondaryAddresses);
        }
        if (validSecondaryAddresses) {
            this.invalidSecondaryAddress = false;
            if (this.addressGroupOpMode === 'EDIT') {
                let index = this.findAddressGroup(this.selectedAddressGroup);
                if (index !== -1) {
                    this.addressGroups[index].primaryAddress = this.addressGroup.primaryAddress;
                    this.addressGroups[index].secondaryAddresses = this.addressGroup.secondaryAddresses;
                    this.addressGroups[index].subnetPrefixLength = this.addressGroup.subnetPrefixLength;
                }
                this.selectedAddressGroup = this.addressGroup;
            } else {
                this.addressGroups.push(this.addressGroup);
            }
            this.addressGroups = [].concat(this.addressGroups);
            this.showAddressGroup = false;
        } else {
            this.invalidSecondaryAddress = true;
            this.invalidSecondaryAddressErrorMsg = 'Secondary addresses provided are not valid IP addresses.';
        }
    }

    findAddressGroup(item): number {
        for (let i = 0; i < this.addressGroups.length; ++i) {
            if (this.addressGroups[i].primaryAddress === item.primaryAddress &&
               this.addressGroups[i].subnetPrefixLength === item.subnetPrefixLength)
               return i;
        }
        return -1;
    }

    interfaceTypeChanged(event) {
        if ((this.interface.type !== 'trunk' && event === 'trunk') ||
            (this.interface.type === 'trunk' && event !== 'trunk')) {
            // type change. so reset connect to
            this.interface.networkName = '';
            this.interface.name = '';
        }
        this.interface.type = event;
        this.showIPScope = (event === 'trunk') ? false : true;
    }

    secondaryAddressChanged(event) {
        if (event.target.value === "") {
            this.addressGroup.secondaryAddresses = [];
        } else {
            this.addressGroup.secondaryAddresses = event.target.value.split(',');
        }
    }

    onNetworkSelectionCancel(event){
        if (!event) {
            this.onCancel(event);
        }
    }

    getRangeValues(ipRanges) {
        let range = '';
        ipRanges.map(function(item, index) {
            if (index !== 0) {
                range += ', ';
            }
            range += item.startAddress + ' - ' + item.endAddress;
        });
        return range;
    }

    getNetworkIpRanges(ipScopes) {
        let formattedValue = '';
        if (typeof ipScopes === "undefined") {
            return formattedValue;
        }
        let me = this;
        ipScopes.map(function(item, index) {
            if (index !== 0) {
                formattedValue += ', ';
            }
            formattedValue += me.getRangeValues(item.networkIpRanges);
        });
        return formattedValue;
    }

    getSecondaryAddresses(addressGroup: IPAssignemntDto): string {
        if (addressGroup.secondaryAddresses) {
            return addressGroup.secondaryAddresses.join();
        }
        return '';
    }

    handleNetworkOpreationError(error: any ) {
        this.networkOperationFailed = true;
        this.isNetworkCallInProgress = false;
        this.errorMessage = error.errorMessage;
    }

    areSecondaryAddressesValid(secondaryAddresses: Array<string> ) {
        let regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        for (let index: number = 0; index < secondaryAddresses.length; index++) {
            if (!regex.test(secondaryAddresses[index]) ) {
              return false;
            }
        }
        return true;
    }
    toggleInterfaceType() {
        if (this.isSubInterface) {
            this.showIPScope = true;
            this.showVNIC = false;
            this.interface.type = '';
        } else {
            this.showVNIC = true;
            if (this.interface.type === 'trunk') {
                this.showIPScope = false;
            }
        }
        if (this.operationMode === 'ADD') {
            this.interface.index = (this.isSubInterface) ? this.getMaxSubInterfaceIndex() : this.currentVNIC;
        }
    }

    onParentIndexChange(event) {
        this.interface.parentInterfaceIndex = parseInt(event);
    }
    isAddEditFormValid() {
        if (this.isSubInterface) {
            if (this.interface.tunnelId >= 1 && this.interface.tunnelId <= 4093 && this.parentInterfaceIndex >=0) {
                return true;
            }
            return false;
        }
    return true;
    }
    canEditTunnelId() {
        if (typeof this.interface.isNew !== "undefined" && this.interface.isNew) {
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/dialogs/add-edit-interface-dialog.component.ts